import React, { useEffect, useMemo, useState } from "react";
import {
  Accordion,
  Alert,
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Nav,
  Modal,
  Spinner,
  ListGroup,
  Row,
  Tooltip,
  OverlayTrigger,
  Badge,
} from "react-bootstrap";
import Select from "../components/ui/AppReactSelect";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit, MdDelete, MdRestaurantMenu, MdAdd, MdList, MdStore, MdFastfood, MdSettings, MdTune, MdVisibility, MdFolder, MdExpandMore, MdHelpOutline, MdSearch, MdClose, MdFileUpload, MdImage } from "react-icons/md";
import { FaInfoCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  createSection,
  fetchSections,
  updateSection,
  deleteSection,
} from "../actions/sectionAction.js";
import { fetchRestaurants } from "../actions/restaurantActions";
import {
  createRestaurantOption,
  createRestaurantOptionGroup,
  fetchOptionGroupsRestaurant,
  deleteOptionGroup,
  deleteOption,
  updateOption,
  updateOptionGroup,
  fetchOptionsRestaurants,
} from "../actions/optionAction.js";
import { toast } from "react-toastify";
import { Switch } from "@material-ui/core";
import DailyPlateControl from "../components/DailyPlateControl";
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
import { getUserFromLocalStorage } from "utilities/user.js";
// Fork, plate and knife on a plain near-white field: the restaurant
// placeholder for a dish that has not been photographed yet.
import placeholderImage from "../assets/img/restaurant-dish-placeholder.png";
import ReadOnlyQuill from "./ReadOnlyQuill.js";
import OutletManager from "components/OutletManager.js";
import MenuImportModal from "./Components/MenuImportModal";
import { useGate, Gated } from "../components/team/Gated";
import { getOptimizedUrl } from "../utilities/imageUpload";
import { apiSetCatalogItemStatus } from "../api";
import AppSelect from "../components/ui/AppSelect";
import BranchAvailabilityGrid from "../components/branch/BranchAvailabilityGrid";
import BranchOffChip, { useBranchOffCounts } from "../components/branch/BranchOffChip";
import BranchMemberNote from "../components/branch/BranchMemberNote";
import { useBranchScope, useVendorLocations } from "../context/BranchScopeContext";
import useBranchStates from "../hooks/useBranchStates";
import { ALL, vendorOwnerIdOf } from "../utilities/vendorScope";

const customFontsCSS = `
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.ql-font-montserrat {
  font-family: 'Montserrat', sans-serif;
}

.ql-editor {
  font-size: 0.875em !important;
}

.ql-editor * {
  font-size: inherit !important;
}

.ql-editor h1 {
  font-size: 1.5em !important;
}

.ql-editor h2 {
  font-size: 1.3em !important;
}

.ql-editor h3 {
  font-size: 1.1em !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideIn {
  from { opacity: 0; transform: translateX(-20px); }
  to { opacity: 1; transform: translateX(0); }
}

.menu-card-adorned {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.menu-header-adorned {
  background: #0a578bff !important;
  color: white !important;
  padding: 24px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.nav-tabs-adorned {
  border-bottom: 2px solid #e9ecef !important;
  background: white;
  padding: 8px 16px 0 16px;
}

.nav-link-adorned {
  border-radius: 8px 8px 0 0 !important;
  margin: 0 4px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.nav-link-adorned:hover {
  transform: translateY(-2px);
  background: #133454ff !important;
  color: white !important;
}

.accordion-item-adorned {
  border: 1px solid #e9ecef !important;
  border-radius: 12px !important;
  margin-bottom: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: slideIn 0.4s ease-out;
}

.accordion-item-adorned .accordion-header-custom {
  transition: background-color 0.3s ease;
}

.accordion-item-adorned .accordion-header-custom:hover {
  background-color: #f8f9fa !important;
}

.accordion-item-adorned:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.product-card-adorned {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
}

.product-card-adorned:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.btn-adorned {
  border-radius: 8px !important;
  font-weight: 500 !important;
  padding: 8px 20px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: #133454ff;
  color: white;
  border-radius: 16px 16px 0 0 !important;
  border: none !important;
  padding: 20px 24px !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.list-group-item-adorned {
  border-radius: 8px !important;
  margin-bottom: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease;
}

.list-group-item-adorned:hover {
  background: #f8f9fa;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  animation: fadeIn 0.5s ease-out;
}

.empty-state-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.dropdown-toggle {
  transition: all 0.3s ease !important;
}

.dropdown-toggle:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.dropdown-item {
  transition: all 0.2s ease !important;
}

.dropdown-item:hover {
  background-color: #f8f9fa !important;
  transform: translateX(4px);
}

.dropdown-item:active {
  background-color: #e9ecef !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

`;

// Custom Accordion Header Component
const CustomAccordionHeader = ({
  section,
  activeKey,
  handleEditSection,
  handleDeleteSection,
  handleAddProductToSection,
  onToggle,
  canEdit = true,
}) => {
  return (
    <div
      className="accordion-header-custom"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontFamily: "'Inter', sans-serif",
        padding: "16px 20px",
        backgroundColor: "white",
        borderBottom: "1px solid #e9ecef",
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => onToggle(String(section._id))}
      >
        <MdExpandMore
          size={24}
          style={{
            marginRight: "12px",
            transition: "transform 0.3s ease",
            transform: activeKey === String(section._id) ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
        <span style={{ marginRight: "auto", fontSize: "16px", fontWeight: "600" }}>
          {section.title}
          <Badge
            bg="primary"
            style={{
              marginLeft: "12px",
              background: "#17385aff",
              borderRadius: "12px",
              padding: "4px 12px",
              fontSize: "12px",
            }}
          >
            {section.products?.length || 0} product(s)
          </Badge>
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {canEdit && (
          <>
        <div
          style={{
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            backgroundColor: "#f8f9fa",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleEditSection(
              section._id,
              section.title,
              section.description,
              section.restaurantId
            );
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#17385aff";
            e.currentTarget.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <MdEdit size="20px" />
        </div>
        <div
          style={{
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            backgroundColor: "#f8f9fa",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteSection(section._id);
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#FB404B";
            e.currentTarget.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <MdDelete size="20px" color="#FB404B" />
        </div>
        <Button
          size="sm"
          className="btn-adorned"
          style={{
            background: "#17385aff",
            color: "white",
            border: "none",
            fontWeight: "600",
            padding: "6px 16px",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleAddProductToSection(
              e,
              section._id,
              section.restaurantId
            );
          }}
        >
          <MdAdd size={16} style={{ marginRight: "4px", verticalAlign: "middle" }} />
          Add product
        </Button>
          </>
        )}
      </div>
    </div>
  );
};

const RestaurantVendorMenu = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const decryptedProfile = getUserFromLocalStorage();
    if (decryptedProfile) {
      setUser(decryptedProfile);
    }
  }, []);

  // The owner's id: a team member manages the business's menu, not its own.
  const vendorId = vendorOwnerIdOf(user) || "";
  const sections = useSelector((state) => state.sections.sections);

  /* Branches (4 Oct 2026): the Branches tab, the "Off at n of m branches"
     chip, and the sold out control acting on the branch picked in the navbar
     (with "All branches" it acts on the dish everywhere, as before). */
  const branchDirectory = useVendorLocations(vendorId || null);
  const branchOff = useBranchOffCounts(vendorId || null);
  const { active: activeBranch, activeLocation } = useBranchScope();
  const plateLocation = activeBranch !== ALL ? activeBranch : null;
  const plateStates = useBranchStates(vendorId || null, plateLocation);
  const restaurants = useSelector((state) => state.restaurants.restaurants);
  // Each outlet's own menu, for the Branches tab: a dish left off a branch's
  // menu is not sold there. An outlet with no menu of its own sells it all.
  const branchMenus = useMemo(() => {
    const out = {};
    (restaurants || []).forEach((r) =>
      (r?.outlets || []).forEach((o) => {
        const ids = (o?.menuItems || []).map((id) => String(id?._id ?? id));
        if (o?._id) out[String(o._id).toLowerCase()] = ids.length ? ids : null;
      })
    );
    return out;
  }, [restaurants]);
  const optionGroups = useSelector((state) => state.options.optionGroups);
  const options = useSelector((state) => state.options.options);
  const loading = useSelector((state) => state.sections.isLoading);
  const restaurantLoading = useSelector((state) => state.restaurants.isLoading);
  const optionLoading = useSelector((state) => state.options.isLoading);
  const isLoadingDeleteOptionGroup = useSelector(
    (state) => state.options.isLoading
  );

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionDescription, setSectionDescription] = useState("");
  const [selectedRestaurantId, setSelectedRestaurantId] = useState("");
  const [activeKey, setActiveKey] = useState([]);
  const [activeNav, setActiveNav] = useState("menu-overview");
  const [restaurantRequired, setRestaurantRequired] = useState(false);
  const [currentSectionId, setCurrentSectionId] = useState(null);

  const [showOptionModal, setShowOptionModal] = useState(false);
  const [optionName, setOptionName] = useState("");
  const [optionPrice, setOptionPrice] = useState(0);

  const [showOptionGroupModal, setShowOptionGroupModal] = useState(false);
  const [optionGroupName, setOptionGroupName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [minOptions, setMinOptions] = useState(0);
  const [maxOptions, setMaxOptions] = useState(0);
  const [currentOptionGroupId, setCurrentOptionGroupId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState(null);
  const [showOptionGroupDeleteModal, setShowOptionGroupDeleteModal] =
    useState(false);
  const [optionGroupToDelete, setOptionGroupToDelete] = useState(null);
  const [showOptionDeleteModal, setShowOptionDeleteModal] = useState(false);
  const [optionToDelete, setOptionToDelete] = useState(null);

  const [showEditOptionModal, setShowEditOptionModal] = useState(false);
  const [currentOptionId, setCurrentOptionId] = useState(null);
  const [editOptionName, setEditOptionName] = useState("");
  const [editOptionPrice, setEditOptionPrice] = useState(0);

  // Product search state
  const [productSearchQuery, setProductSearchQuery] = useState("");
  // Dishes can be added before they are photographed (a bulk menu import, or a
  // kitchen onboarding from a printed menu), so the ones still waiting have to
  // be findable. The import modal tells operators to look here.
  const [photolessOnly, setPhotolessOnly] = useState(false);

  // Image preview state
  const [hoveredImage, setHoveredImage] = useState(null);
  const [imagePreviewPosition, setImagePreviewPosition] = useState({ x: 0, y: 0 });
  const [editOptionEnabled, setEditOptionEnabled] = useState(true);

  const [showCollectionModal, setShowCollectionModal] = useState(false);

  // Bulk menu import (workbook + photo files). Same modal the admin drawer
  // uses; the backend scopes every write to this vendor via the ownership
  // guards in middleware/optionAccess.js and the owner-chain resolvers.
  const [showMenuImport, setShowMenuImport] = useState(false);
  // Vendor team permissions: sections, products, options and import are
  // catalogue:edit; switching a product on or off is catalogue:activate.
  const catalogueGate = useGate("catalogue:edit");
  const activateGate = useGate("catalogue:activate");
  const [collectionName, setCollectionName] = useState("");
  const [collectionDescription, setCollectionDescription] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (vendorId) {
      dispatch(fetchRestaurants(vendorId));
      dispatch(fetchSections(vendorId));
      dispatch(fetchOptionGroupsRestaurant(vendorId));
      dispatch(fetchOptionsRestaurants(vendorId));
    }
  }, [dispatch, vendorId]);

  useEffect(() => {
    if (sections.length > 0) {
      setActiveKey(sections.map((section) => String(section._id)));
    }
  }, [sections]);

  const handleMenuSectionSubmit = (e) => {
    e.preventDefault();
    if (!selectedRestaurantId) {
      setRestaurantRequired(true);
      return;
    }
    dispatch(
      createSection(
        {
          title: sectionTitle,
          description: sectionDescription,
          restaurantId: selectedRestaurantId,
        },
        vendorId
      )
    );
    setShowCreateModal(false);
    resetForm();
  };

  const handleSectionEditSubmit = (e) => {
    e.preventDefault();
    if (!selectedRestaurantId) {
      setRestaurantRequired(true);
      return;
    }
    dispatch(
      updateSection(currentSectionId, {
        title: sectionTitle,
        description: sectionDescription,
        restaurantId: selectedRestaurantId,
      })
    );
    setShowEditModal(false);
    resetForm();
  };

  const handleAddRestaurantProductClick = () => {
    history.push("/admin/menu-create");
  };

  const handleSectionClick = (eventKey) => {
    setActiveKey((prevActiveKey) =>
      prevActiveKey.includes(eventKey)
        ? prevActiveKey.filter((key) => key !== eventKey)
        : [...prevActiveKey, eventKey]
    );
  };

  const handleEditProduct = (productId) => {
    const productToEdit = sections
      .flatMap((section) => section.products)
      .find((product) => product._id === productId);

    if (productToEdit) {
      history.push({
        pathname: `/admin/edit-menu-product/${productId}`,
        state: { productDetails: productToEdit },
      });
    } else {
      console.error("Product not found!");
    }
  };

  // Quick per-item activate/deactivate — unified endpoint; storefronts update
  // live via the catalog:public `product:statusChanged` socket event.
  const handleToggleProductStatus = async (e, product) => {
    e.stopPropagation();
    const next = !product.enabled;
    try {
      await apiSetCatalogItemStatus("restaurant", product._id, next);
      toast.success(`"${product.name}" ${next ? "activated" : "deactivated"}`);
      dispatch(fetchSections(vendorId));
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to change product status"
      );
    }
  };

  const handleAddProductToSection = (e, sectionId, restaurantId) => {
    e.preventDefault();
    history.push({
      pathname: "/admin/menu-create",
      state: { sectionId, restaurantId },
    });
  };

  const handleEditSection = (
    sectionId,
    sectionTitle,
    sectionDescription,
    restaurantId
  ) => {
    setCurrentSectionId(sectionId);
    setSectionTitle(sectionTitle);
    setSectionDescription(sectionDescription);
    setSelectedRestaurantId(restaurantId || ""); // Ensure this line is setting the correct value or default to an empty string
    setRestaurantRequired(false);
    setShowEditModal(true);
  };

  const handleOptionSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createRestaurantOption({
        name: optionName,
        price: optionPrice,
        owner: vendorId,
      })
    );
    setShowOptionModal(false);
    resetOptionForm();
  };

  const handleOptionGroupSubmit = async (e) => {
    e.preventDefault();

    if (!selectedRestaurantId) {
      setRestaurantRequired(true);
      return;
    }

    const optionGroupData = {
      name: optionGroupName,
      restaurantProductId: selectedRestaurantId,
      options: selectedOptions.map((option) => ({
        value: option.value,
        mandatory: minOptions > 0,
      })),
      minOptions,
      maxOptions,
      owner: vendorId,
    };

    if (currentOptionGroupId) {
      await dispatch(updateOptionGroup(currentOptionGroupId, optionGroupData));
    } else {
      await dispatch(createRestaurantOptionGroup(optionGroupData));
    }

    dispatch(fetchOptionGroupsRestaurant(vendorId));

    setShowOptionGroupModal(false);
    resetOptionGroupForm();
  };

  const handleEditOptionGroup = (optionGroup) => {
    setCurrentOptionGroupId(optionGroup._id);
    setOptionGroupName(optionGroup.name);
    setSelectedOptions(
      optionGroup.options
        .map((option) => {
          if (option.option && option.option._id) {
            return {
              value: option.option._id,
              label: `${option.option.name} - ${new Intl.NumberFormat("en-UG", {
                style: "currency",
                currency: "UGX",
              }).format(option.option.price)}`,
              mandatory: option.mandatory,
            };
          }
          return null;
        })
        .filter((option) => option !== null)
    );
    setMinOptions(optionGroup.minOptions);
    setMaxOptions(optionGroup.maxOptions);
    setSelectedRestaurantId(optionGroup.restaurantId || ""); // Set selectedRestaurantId
    setRestaurantRequired(false);
    setShowOptionGroupModal(true);
  };

  const handleDeleteOption = (optionId) => {
    setOptionToDelete(optionId);
    setShowOptionDeleteModal(true);
  };

  const confirmDeleteOption = async () => {
    try {
      await dispatch(deleteOption(optionToDelete));
      setShowOptionDeleteModal(false);
      setOptionToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the option. Please try again.");
    }
  };

  const handleDeleteSection = (sectionId) => {
    setSectionToDelete(sectionId);
    setShowDeleteModal(true);
  };

  const confirmDeleteSection = async () => {
    try {
      await dispatch(deleteSection(sectionToDelete));
      toast.success("Section and its products deleted successfully");
      setShowDeleteModal(false);
      setSectionToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the section. Please try again.");
    }
  };

  const handleDeleteOptionGroup = (optionGroupId) => {
    setOptionGroupToDelete(optionGroupId);
    setShowOptionGroupDeleteModal(true);
  };

  const confirmDeleteOptionGroup = async () => {
    try {
      await dispatch(deleteOptionGroup(optionGroupToDelete));
      setShowOptionGroupDeleteModal(false);
      setOptionGroupToDelete(null);
    } catch (error) {
      toast.error("Failed to delete the option group. Please try again.");
    }
  };

  const handleEditOption = (option) => {
    setCurrentOptionId(option._id);
    setEditOptionName(option.name);
    setEditOptionPrice(option.price);
    setEditOptionEnabled(option.enabled);
    setShowEditOptionModal(true);
  };

  const handleEditOptionSubmit = (e) => {
    e.preventDefault();
    const updatedOption = {
      name: editOptionName,
      price: editOptionPrice,
      enabled: editOptionEnabled,
    };
    dispatch(updateOption(currentOptionId, updatedOption));
    setShowEditOptionModal(false);
    resetEditOptionForm();
  };

  const handleCloseOptionGroupModal = () => {
    resetOptionGroupForm();
    setShowOptionGroupModal(false);
  };

  const resetForm = () => {
    setSectionTitle("");
    setSectionDescription("");
    setSelectedRestaurantId("");
    setRestaurantRequired(false);
  };

  const resetOptionForm = () => {
    setOptionName("");
    setOptionPrice(0);
  };

  const resetOptionGroupForm = () => {
    setOptionGroupName("");
    setSelectedRestaurantId("");
    setSelectedOptions([]);
    setMinOptions(0);
    setMaxOptions(0);
    setCurrentOptionGroupId(null);
    setRestaurantRequired(false);
  };

  const resetEditOptionForm = () => {
    setEditOptionName("");
    setEditOptionPrice(0);
    setCurrentOptionId(null);
  };

  return (
    <Col md="10">
      <style>{customFontsCSS}</style>
      <Card className="menu-card-adorned">
        <Card.Header className="menu-header-adorned d-flex justify-content-between align-items-center">
          <div>
            <div className="d-flex align-items-center mb-2">
              <MdRestaurantMenu size={32} style={{ marginRight: "12px" }} />
              <Card.Title as="h3" style={{ marginBottom: 0, fontSize: "28px", fontWeight: "700", fontFamily: "'Inter', sans-serif", color: "white" }}>
                Menu Management
              </Card.Title>
            </div>
            <p style={{ marginBottom: 0, opacity: 0.9, fontSize: "14px" }}>Manage your restaurant sections, products & options</p>
          </div>
          <Gated perm="catalogue:edit">
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-add-menu"
              variant="light"
              style={{
                backgroundColor: "white",
                color: "#133454ff",
                fontWeight: "600",
                border: "1px solid #e9ecef",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "8px 16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <MdAdd size={20} />
              <span>Add New</span>
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                padding: "8px",
                minWidth: "200px",
              }}
            >
              <Dropdown.Item
                onClick={() => setShowCreateModal(true)}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "500",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <MdList size={18} />
                <span>Add section</span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={handleAddRestaurantProductClick}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "500",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <MdFastfood size={18} />
                <span>Add product</span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setShowCollectionModal(true)}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "500",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <MdFolder size={18} />
                <span>Add collection</span>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setShowMenuImport(true)}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: "500",
                  padding: "10px 12px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <MdFileUpload size={18} />
                <span>Import menu (bulk)</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          </Gated>
        </Card.Header>
        <Nav
          variant="tabs"
          activeKey={activeNav}
          onSelect={(selectedKey) => setActiveNav(selectedKey)}
          className="nav-tabs-adorned"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            overflowX: "auto",
            whiteSpace: "nowrap",
            display: "flex",
            flexWrap: "nowrap",
          }}
        >
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="menu-overview"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "menu-overview"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "menu-overview" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdList size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Menu Overview
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="outlets"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "outlets"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "outlets" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdStore size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Outlets
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="products"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "products"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "products" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdFastfood size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Products
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="option-groups"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "option-groups"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "option-groups" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdTune size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Option Groups
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="options"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "options"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "options" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdSettings size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Options
            </Nav.Link>
          </Nav.Item>
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="simulation"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "simulation"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "simulation" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdVisibility size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              Simulation
            </Nav.Link>
          </Nav.Item>
          {branchDirectory.hasBranches && (
            <Nav.Item style={{ flexShrink: 0 }}>
              <Nav.Link
                eventKey="branches"
                className="nav-link-adorned"
                style={{
                  background: activeNav === "branches" ? "#17385aff" : "transparent",
                  color: activeNav === "branches" ? "white" : "#495057",
                  cursor: "pointer",
                  fontSize: "14px",
                  padding: "10px 20px",
                  border: "none",
                }}
              >
                <MdStore size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
                Branches
              </Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item style={{ flexShrink: 0 }}>
            <Nav.Link
              eventKey="how-it-works"
              className="nav-link-adorned"
              style={{
                background:
                  activeNav === "how-it-works"
                    ? "#17385aff"
                    : "transparent",
                color: activeNav === "how-it-works" ? "white" : "#495057",
                cursor: "pointer",
                fontSize: "14px",
                padding: "10px 20px",
                border: "none",
              }}
            >
              <MdHelpOutline size={16} style={{ marginRight: "6px", verticalAlign: "middle" }} />
              How it works
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Card.Body style={{ padding: "24px" }}>
          {loading || restaurantLoading || optionLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
              <div className="text-center">
                <Spinner animation="border" role="status" style={{ width: "3rem", height: "3rem", color: "#17385aff" }}>
                  <span className="sr-only">Loading...</span>
                </Spinner>
                <p style={{ marginTop: "16px", color: "#6c757d", fontFamily: "'Inter', sans-serif" }}>Loading your menu...</p>
              </div>
            </div>
          ) : (
            <>
              {activeNav === "menu-overview" && branchDirectory.hasBranches && (
                <BranchMemberNote itemsWord="dishes" onOpenBranches={() => setActiveNav("branches")} />
              )}
              {activeNav === "menu-overview" && (
                <div>
                  {sections.length === 0 ? (
                    <div className="empty-state">
                      <div className="empty-state-icon"><MdList size={64} /></div>
                      <h4 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "600" }}>No Sections Yet</h4>
                      <p>Create your first menu section to get started</p>
                      <Gated perm="catalogue:edit">
                      <Button
                        variant="primary"
                        className="btn-adorned"
                        onClick={() => setShowCreateModal(true)}
                        style={{ background: "#17385aff", border: "none", marginTop: "16px" }}
                      >
                        Create Section
                      </Button>
                      </Gated>
                    </div>
                  ) : (
                    <>
                      {/* ── Summary stat strip ── */}
                      {(() => {
                        const allProducts = sections.flatMap((s) => s.products || []);
                        const chips = [
                          { label: "Sections",         value: sections.length,                              bg: "#e3f2fd", color: "#1565c0", border: "#90caf9" },
                          { label: "Total Listings",    value: allProducts.length,                           bg: "#f3e5f5", color: "#6a1b9a", border: "#ce93d8" },
                          { label: "Active Listings",   value: allProducts.filter((p) => p.enabled).length,  bg: "#e8f5e9", color: "#2e7d32", border: "#a5d6a7" },
                          { label: "Inactive Listings", value: allProducts.filter((p) => !p.enabled).length, bg: "#fff3e0", color: "#e65100", border: "#ffcc80" },
                        ];
                        return (
                          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "18px" }}>
                            {chips.map(({ label, value, bg, color, border }) => (
                              <div key={label} style={{ background: bg, border: `1.5px solid ${border}`, borderRadius: "10px", padding: "10px 18px", minWidth: "110px", textAlign: "center" }}>
                                <div style={{ fontSize: "1.4rem", fontWeight: 800, color, lineHeight: 1.1 }}>{value}</div>
                                <div style={{ fontSize: "0.72rem", fontWeight: 700, color, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: "3px" }}>{label}</div>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                    <Accordion
                      defaultActiveKey={activeKey}
                      activeKey={activeKey}
                      onSelect={handleSectionClick}
                    >
                      {sections.map((section, index) => (
                        <Accordion.Item
                          eventKey={String(section._id)}
                          key={section._id}
                          className="accordion-item-adorned"
                          style={{ animationDelay: `${index * 0.1}s` }}
                        >
                          <CustomAccordionHeader
                            section={section}
                            activeKey={activeKey}
                            handleEditSection={handleEditSection}
                            handleDeleteSection={handleDeleteSection}
                            handleAddProductToSection={handleAddProductToSection}
                            onToggle={handleSectionClick}
                            canEdit={catalogueGate.allowed}
                          />
                          <Accordion.Body>
                            {section.products &&
                              section.products.map((product) => (
                                <div
                                  key={product._id}
                                  className="d-flex align-items-center justify-content-between"
                                  style={{
                                    marginBottom: "10px",
                                    borderBottom: "1px solid #ccc",
                                    paddingBottom: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleEditProduct(product._id)}
                                >
                                  <div className="d-flex align-items-center">
                                    <img
                                      src={getOptimizedUrl(product.image, "thumbnail") || placeholderImage}
                                      alt={product.name}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        marginRight: "10px",
                                        borderRadius: "20%",
                                      }}
                                    />
                                    <div>
                                      <h6>
                                        {product.name}
                                        <BranchOffChip
                                          count={branchOff.counts.get(String(product._id))}
                                          total={branchOff.total}
                                        />
                                      </h6>
                                      <div
                                        style={{
                                          marginBottom: 0,
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* <ReactQuill
                                                                        value={product.description || ''}
                                                                        readOnly={true}
                                                                        theme="bubble"
                                                                        modules={{ toolbar: false }}
                                                                        style={{ fontSize: '0.875em' }}
                                                                    /> */}
                                        <ReadOnlyQuill
                                          value={product.description || ""}
                                        />
                                      </div>
                                      {!product.enabled && (
                                        <p
                                          style={{
                                            marginBottom: 0,
                                            fontSize: "12px",
                                            color: "red",
                                          }}
                                        >
                                          (Deactivated)
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontFamily: "monospace",
                                        fontWeight: "lighter",
                                        marginRight: 10,
                                      }}
                                    >
                                      {new Intl.NumberFormat("en-UG", {
                                        style: "currency",
                                        currency: "UGX",
                                      }).format(product.price)}
                                    </div>
                                    {product.enabled && (
                                      <DailyPlateControl
                                        product={product}
                                        location={plateLocation}
                                        locationName={activeLocation?.name || null}
                                        branchState={plateStates.states.get(String(product._id)) || null}
                                        onChanged={(data) => {
                                          if (plateLocation) {
                                            plateStates.merge(data?.rows);
                                            branchOff.refresh();
                                          } else {
                                            dispatch(fetchSections(vendorId));
                                          }
                                        }}
                                      />
                                    )}
                                    <span
                                      onClick={(e) => e.stopPropagation()}
                                      title={
                                        !activateGate.allowed
                                          ? activateGate.title
                                          : product.enabled
                                            ? "Deactivate this item (hides it from shoppers instantly)"
                                            : "Activate this item (shoppers see it instantly)"
                                      }
                                    >
                                      <Switch
                                        size="small"
                                        checked={!!product.enabled}
                                        disabled={!activateGate.allowed}
                                        onChange={(e) =>
                                          handleToggleProductStatus(e, product)
                                        }
                                        color="primary"
                                      />
                                    </span>
                                  </div>
                                </div>
                              ))}
                            {(!section.products ||
                              section.products.length === 0) && (
                                <div>No products found.</div>
                              )}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                    </>
                  )}
                </div>
              )}
              {activeNav === "outlets" && restaurants.length > 0 && (
                <OutletManager
                  restaurantId={restaurants[0]._id}
                  sections={sections}
                  readOnly={true}
                  onChanged={() => dispatch(fetchRestaurants(vendorId))}
                />
              )}
              {activeNav === "products" && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h4 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "700", color: "#17385aff", marginBottom: "4px" }}>
                        Products
                      </h4>
                      <p style={{ color: "#6c757d", fontSize: "14px", marginBottom: 0 }}>
                        Manage your restaurant menu items
                      </p>
                    </div>
                    {/* Search Bar */}
                    <div style={{ position: "relative", width: "300px" }}>
                      <MdSearch
                        size={20}
                        style={{
                          position: "absolute",
                          left: "14px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#6c757d"
                        }}
                      />
                      <Form.Control
                        type="text"
                        placeholder="Search products..."
                        value={productSearchQuery}
                        onChange={(e) => setProductSearchQuery(e.target.value)}
                        style={{
                          paddingLeft: "44px",
                          paddingRight: productSearchQuery ? "40px" : "14px",
                          borderRadius: "12px",
                          border: "1px solid #e9ecef",
                          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
                          height: "44px",
                          fontSize: "14px",
                        }}
                      />
                      {productSearchQuery && (
                        <Button
                          variant="link"
                          onClick={() => setProductSearchQuery("")}
                          style={{
                            position: "absolute",
                            right: "8px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            padding: "4px",
                            color: "#6c757d",
                          }}
                        >
                          <MdClose size={18} />
                        </Button>
                      )}
                    </div>
                  </div>
                  {(() => {
                    const photoless = (sections || []).reduce(
                      (n, sec) => n + (sec.products || []).filter((p) => !p.image).length,
                      0
                    );
                    if (!photoless) return null;
                    return (
                      <div className="mb-3">
                        <Button
                          variant={photolessOnly ? "warning" : "outline-warning"}
                          size="sm"
                          onClick={() => setPhotolessOnly((prev) => !prev)}
                          style={{ borderRadius: "10px", fontWeight: 700, fontSize: "13px" }}
                        >
                          <MdImage size={16} style={{ marginRight: 6, marginTop: -2 }} />
                          {photolessOnly
                            ? `Showing ${photoless} without a photo`
                            : `${photoless} product${photoless === 1 ? "" : "s"} without a photo`}
                        </Button>
                        <span style={{ color: "#6c757d", fontSize: "13px", marginLeft: 10 }}>
                          They are live and orderable. Add the pictures whenever you have them.
                        </span>
                      </div>
                    );
                  })()}
                  <Row>
                    {sections.map(
                      (section) =>
                        section.products &&
                        section.products
                          .filter(
                            (product) =>
                              (product.name.toLowerCase().includes(productSearchQuery.toLowerCase()) ||
                                (product.description &&
                                  product.description.toLowerCase().includes(productSearchQuery.toLowerCase()))) &&
                              (!photolessOnly || !product.image)
                          )
                          .map((product) => (
                            <Col md={6} lg={4} key={product._id} className="mb-4">
                              <Card
                                className="product-card-adorned h-100"
                                style={{
                                  border: "1px solid #e9ecef",
                                  borderRadius: "16px",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                                  overflow: "hidden",
                                  transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.12)";
                                  e.currentTarget.style.transform = "translateY(-4px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.06)";
                                  e.currentTarget.style.transform = "translateY(0)";
                                }}
                              >
                                {/* Product Image with hover preview */}
                                <div
                                  style={{
                                    position: "relative",
                                    overflow: "hidden",
                                    height: "180px",
                                    background: "#f8f9fa",
                                    cursor: "pointer",
                                  }}
                                  onMouseEnter={(e) => {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    setHoveredImage(product.image || placeholderImage);
                                    setImagePreviewPosition({
                                      x: rect.left + rect.width + 20,
                                      y: rect.top,
                                    });
                                  }}
                                  onMouseLeave={() => setHoveredImage(null)}
                                >
                                  <img
                                    src={getOptimizedUrl(product.image, "thumbnail") || placeholderImage}
                                    alt={product.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      transition: "transform 0.4s ease",
                                    }}
                                  />
                                  {/* Hover overlay with zoom icon */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      background: "rgba(0, 0, 0, 0.3)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      opacity: 0,
                                      transition: "opacity 0.3s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.opacity = "1";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.opacity = "0";
                                    }}
                                  >
                                    <MdSearch size={32} color="#ffffff" />
                                  </div>
                                  {/* Section badge */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "12px",
                                      left: "12px",
                                      background: "rgba(23, 56, 90, 0.9)",
                                      color: "#fff",
                                      padding: "4px 10px",
                                      borderRadius: "20px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {section.name}
                                  </div>
                                </div>

                                <Card.Body style={{ padding: "16px" }}>
                                  <Card.Title style={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                    marginBottom: "8px",
                                    color: "#1a1a2e"
                                  }}>
                                    {product.name}
                                  </Card.Title>

                                  <div style={{ fontSize: "13px", color: "#6c757d", marginBottom: "12px", minHeight: "40px" }}>
                                    <ReadOnlyQuill
                                      value={
                                        product.description ||
                                        "No description available"
                                      }
                                    />
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center">
                                    <div
                                      style={{
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: "#059669",
                                      }}
                                    >
                                      {new Intl.NumberFormat("en-UG", {
                                        style: "currency",
                                        currency: "UGX",
                                      }).format(product.price)}
                                    </div>
                                    <Button
                                      size="sm"
                                      onClick={() => handleEditProduct(product._id)}
                                      style={{
                                        background: "#17385aff",
                                        border: "none",
                                        borderRadius: "8px",
                                        padding: "8px 16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Edit
                                    </Button>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          ))
                    )}
                  </Row>
                </div>
              )}
              {activeNav === "option-groups" && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h4 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "700", color: "#17385aff", marginBottom: "4px" }}>
                        Option Groups
                      </h4>
                      <p style={{ color: "#6c757d", fontSize: "14px", marginBottom: 0 }}>
                        Create customization groups for your products (e.g., "Free Drink", "Size", "Toppings")
                      </p>
                    </div>
                    <Button
                      variant="primary"
                      className="btn-adorned"
                      onClick={() => setShowOptionGroupModal(true)}
                      disabled={optionLoading || !catalogueGate.allowed}
                      title={catalogueGate.title}
                      style={{
                        background: "linear-gradient(135deg, #17385aff 0%, #0a578bff 100%)",
                        border: "none",
                        boxShadow: "0 4px 12px rgba(23, 56, 90, 0.3)",
                      }}
                    >
                      {optionLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <>
                          <MdAdd size={18} style={{ marginRight: "6px", verticalAlign: "middle" }} />
                          Add Option Group
                        </>
                      )}
                    </Button>
                  </div>

                  {optionGroups.length === 0 ? (
                    <div className="empty-state" style={{ background: "#f8f9fa", borderRadius: "16px", padding: "40px" }}>
                      <MdTune size={48} style={{ color: "#6c757d", marginBottom: "12px" }} />
                      <h5 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "600", color: "#495057" }}>No Option Groups Yet</h5>
                      <p style={{ color: "#6c757d", fontSize: "14px" }}>Create option groups to add customizations to your products</p>
                    </div>
                  ) : (
                    <Row>
                      {optionGroups.map((optionGroup) => {
                        const isPickOne = optionGroup.minOptions === 1 && optionGroup.maxOptions === 1;
                        const isRequired = optionGroup.minOptions > 0;
                        const optionCount = optionGroup.options?.length || 0;

                        return (
                          <Col md={6} lg={4} key={optionGroup._id} className="mb-3">
                            <Card
                              onClick={() => handleEditOptionGroup(optionGroup)}
                              style={{
                                cursor: "pointer",
                                border: "1px solid #e9ecef",
                                borderRadius: "16px",
                                transition: "all 0.3s ease",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                                overflow: "hidden",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.12)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.06)";
                              }}
                            >
                              <Card.Body style={{ padding: "20px" }}>
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                  <div
                                    style={{
                                      width: "44px",
                                      height: "44px",
                                      borderRadius: "12px",
                                      background: isPickOne
                                        ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                                        : "linear-gradient(135deg, #17385aff 0%, #0a578bff 100%)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "white",
                                    }}
                                  >
                                    <MdTune size={22} />
                                  </div>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-delete-${optionGroup._id}`}>
                                        Delete Option Group
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      size="sm"
                                      {...catalogueGate.disabledProps}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteOptionGroup(optionGroup._id);
                                      }}
                                      style={{
                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                                        border: "none",
                                        boxShadow: "0 2px 6px rgba(220, 53, 69, 0.3)",
                                      }}
                                    >
                                      <MdDelete size={16} color="#ffffff" />
                                    </Button>
                                  </OverlayTrigger>
                                </div>

                                <h5 style={{
                                  fontFamily: "'Inter', sans-serif",
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  marginBottom: "8px",
                                  color: "#1a1a2e"
                                }}>
                                  {optionGroup.name}
                                </h5>

                                <div className="d-flex flex-wrap gap-2 mb-3">
                                  {isRequired && (
                                    <Badge
                                      bg={isPickOne ? "success" : "warning"}
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        padding: "4px 8px",
                                        borderRadius: "6px"
                                      }}
                                    >
                                      {isPickOne ? "Pick One" : "Required"}
                                    </Badge>
                                  )}
                                  {!isRequired && (
                                    <Badge
                                      bg="secondary"
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        padding: "4px 8px",
                                        borderRadius: "6px"
                                      }}
                                    >
                                      Optional
                                    </Badge>
                                  )}
                                  <Badge
                                    bg="light"
                                    text="dark"
                                    style={{
                                      fontSize: "11px",
                                      fontWeight: "500",
                                      padding: "4px 8px",
                                      borderRadius: "6px",
                                      border: "1px solid #e9ecef"
                                    }}
                                  >
                                    {optionCount} option{optionCount !== 1 ? "s" : ""}
                                  </Badge>
                                </div>

                                <div style={{
                                  background: "#f8f9fa",
                                  borderRadius: "10px",
                                  padding: "12px",
                                  fontSize: "13px",
                                  color: "#495057"
                                }}>
                                  <div className="d-flex justify-content-between">
                                    <span>Min selections:</span>
                                    <strong>{optionGroup.minOptions}</strong>
                                  </div>
                                  <div className="d-flex justify-content-between mt-1">
                                    <span>Max selections:</span>
                                    <strong>{optionGroup.maxOptions === 0 ? "Unlimited" : optionGroup.maxOptions}</strong>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                  )}
                </div>
              )}
              {activeNav === "options" && (
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h4 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "700", color: "#17385aff", marginBottom: "4px" }}>
                        Options
                      </h4>
                      <p style={{ color: "#6c757d", fontSize: "14px", marginBottom: 0 }}>
                        Create individual options that can be added to option groups (e.g., "Fanta", "Sprite", "Large", "Extra Cheese")
                      </p>
                    </div>
                    <Button
                      variant="primary"
                      className="btn-adorned"
                      onClick={() => setShowOptionModal(true)}
                      {...catalogueGate.disabledProps}
                      style={{
                        background: "linear-gradient(135deg, #0474e3ff 0%, #0056b3 100%)",
                        border: "none",
                        boxShadow: "0 4px 12px rgba(4, 116, 227, 0.3)",
                      }}
                    >
                      <MdAdd size={18} style={{ marginRight: "6px", verticalAlign: "middle" }} />
                      Add Option
                    </Button>
                  </div>

                  {options.length === 0 ? (
                    <div className="empty-state" style={{ background: "#f8f9fa", borderRadius: "16px", padding: "40px" }}>
                      <MdSettings size={48} style={{ color: "#6c757d", marginBottom: "12px" }} />
                      <h5 style={{ fontFamily: "'Inter', sans-serif", fontWeight: "600", color: "#495057" }}>No Options Yet</h5>
                      <p style={{ color: "#6c757d", fontSize: "14px" }}>Create options like drinks, sizes, or toppings to use in option groups</p>
                    </div>
                  ) : (
                    <Row>
                      {options.map((option) => (
                        <Col md={6} lg={4} key={option._id} className="mb-3">
                          <Card
                            style={{
                              border: "1px solid #e9ecef",
                              borderRadius: "14px",
                              transition: "all 0.3s ease",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                              overflow: "hidden",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.04)";
                            }}
                          >
                            <Card.Body style={{ padding: "16px" }}>
                              <div className="d-flex justify-content-between align-items-start">
                                <div className="d-flex align-items-center gap-3">
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "10px",
                                      background: option.enabled
                                        ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                                        : "linear-gradient(135deg, #6c757d 0%, #495057 100%)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {option.name.charAt(0).toUpperCase()}
                                  </div>
                                  <div>
                                    <h6 style={{
                                      fontFamily: "'Inter', sans-serif",
                                      fontWeight: "600",
                                      fontSize: "15px",
                                      marginBottom: "4px",
                                      color: option.enabled ? "#1a1a2e" : "#6c757d"
                                    }}>
                                      {option.name}
                                      {!option.enabled && (
                                        <Badge
                                          bg="secondary"
                                          style={{
                                            marginLeft: "8px",
                                            fontSize: "10px",
                                            fontWeight: "500"
                                          }}
                                        >
                                          Disabled
                                        </Badge>
                                      )}
                                    </h6>
                                    <span style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: option.price === 0 ? "#10b981" : "#0474e3ff",
                                    }}>
                                      {option.price === 0
                                        ? "Free"
                                        : new Intl.NumberFormat("en-UG", {
                                          style: "currency",
                                          currency: "UGX",
                                        }).format(option.price)
                                      }
                                    </span>
                                  </div>
                                </div>
                                <div className="d-flex gap-2">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Edit Option</Tooltip>}
                                  >
                                    <Button
                                      size="sm"
                                      {...catalogueGate.disabledProps}
                                      onClick={() => handleEditOption(option)}
                                      style={{
                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        background: "linear-gradient(135deg, #0474e3ff 0%, #0056b3 100%)",
                                        border: "none",
                                        boxShadow: "0 2px 6px rgba(4, 116, 227, 0.3)",
                                      }}
                                    >
                                      <MdEdit size={14} color="#ffffff" />
                                    </Button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Delete Option</Tooltip>}
                                  >
                                    <Button
                                      size="sm"
                                      {...catalogueGate.disabledProps}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteOption(option._id);
                                      }}
                                      style={{
                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                                        border: "none",
                                        boxShadow: "0 2px 6px rgba(220, 53, 69, 0.3)",
                                      }}
                                    >
                                      <MdDelete size={16} color="#ffffff" />
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
              )}
              {activeNav === "branches" && branchDirectory.hasBranches && (
                <BranchAvailabilityGrid
                  vendorUserId={vendorId}
                  products={(sections || []).flatMap((section) => section.products || [])}
                  branchMenus={branchMenus}
                  onChanged={() => {
                    branchOff.refresh();
                    plateStates.refresh();
                  }}
                />
              )}
              {activeNav === "simulation" && (
                <div style={{ padding: "10px" }}>
                  <p style={{ color: "#002333" }}>
                    This section simulates how the products and sections will
                    look for web users in production.
                  </p>
                  {sections
                    .filter(
                      (section) =>
                        section.products &&
                        section.products.some((product) => product.enabled)
                    )
                    .map((section) => (
                      <div
                        key={section._id}
                        id={`section-${section._id}`}
                        style={{ marginBottom: "20px" }}
                      >
                        <div style={{ marginBottom: "10px" }}>
                          <h2 style={{ fontSize: "1.2em" }}>{section.title}</h2>
                          {/* <ReactQuill
                                                    value={section.description || ''}
                                                    readOnly={true}
                                                    theme="bubble"
                                                    modules={{ toolbar: false }}
                                                    style={{ fontSize: '0.875em' }}
                                                /> */}
                          <ReadOnlyQuill value={section.description || ""} />
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(150px, 1fr))",
                            gap: "15px",
                          }}
                        >
                          {section.products &&
                            section.products.map((product) => (
                              <div
                                key={product._id}
                                style={{
                                  border: "0.5px solid #ccc",
                                  padding: "10px",
                                  textAlign: "left",
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                  borderRadius: "8px",
                                  backgroundColor: "white",
                                  transition: "transform 0.2s",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    aspectRatio: "1/1",
                                    overflow: "hidden",
                                    marginBottom: "10px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <img
                                    src={getOptimizedUrl(product.image, "thumbnail") || placeholderImage}
                                    alt={product.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <div style={{ paddingTop: "5px" }}>
                                  <h5
                                    style={{
                                      fontSize: "14px",
                                      margin: "10px 0 5px",
                                      color: "#333",
                                    }}
                                  >
                                    {product.name}
                                  </h5>
                                  <div style={{ fontSize: "12px" }}>
                                    {/* <ReactQuill
                                                                    value={product.description || 'No description available.'}
                                                                    readOnly={true}
                                                                    theme="bubble"
                                                                    modules={{ toolbar: false }}
                                                                    style={{ fontSize: '0.875em' }}
                                                                /> */}
                                    <ReadOnlyQuill
                                      value={
                                        product.description ||
                                        "No description available."
                                      }
                                    />
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "1em",
                                      color: "#2E5902",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {new Intl.NumberFormat("en-UG", {
                                      style: "currency",
                                      currency: "UGX",
                                    }).format(product.price)}
                                  </p>
                                  {!product.enabled && (
                                    <p
                                      style={{
                                        marginBottom: 0,
                                        fontSize: "12px",
                                        color: "red",
                                      }}
                                    >
                                      (Deactivated)
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    ))}
                </div>
              )}
              {activeNav === "how-it-works" && (
                <div style={{ padding: "20px" }}>
                  <div style={{ marginBottom: "30px" }}>
                    <h4 style={{ color: "#17385aff", marginBottom: "10px", fontFamily: "'Inter', sans-serif", fontWeight: "700" }}>
                      Welcome to Restaurant Menu Management
                    </h4>
                    <p style={{ color: "#6c757d", fontSize: "14px", fontFamily: "'Inter', sans-serif" }}>
                      This comprehensive guide will help you create and manage your restaurant menu efficiently.
                    </p>
                  </div>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>1. Getting Started</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>The Restaurant Menu Management system provides a complete solution for organizing your dishes and offerings.</p>
                        <ul>
                          <li><strong>Sections:</strong> Categories that organize your menu (e.g., "Appetizers", "Main Courses", "Desserts", "Beverages")</li>
                          <li><strong>Products:</strong> Individual dishes and food items</li>
                          <li><strong>Options & Option Groups:</strong> Customizations like sizes, toppings, and add-ons</li>
                          <li><strong>Outlets:</strong> Manage multiple restaurant locations with different menus</li>
                        </ul>
                        <p style={{ marginTop: "10px", padding: "10px", backgroundColor: "#e3f2fd", borderLeft: "4px solid #17385aff", fontSize: "13px" }}>
                          <strong>Tip:</strong> Begin by creating menu sections, then add dishes to each section, and finally set up options for customization.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>2. Creating Sections</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Sections organize your menu into logical categories that make it easy for customers to browse.</p>
                        <ol>
                          <li>Click the <strong>"Add New"</strong> dropdown and select <strong>"Add section"</strong></li>
                          <li>Enter a descriptive section title (e.g., "Starters", "Grilled Specialties", "Chef's Recommendations")</li>
                          <li>Add a description to explain what's in this section (optional but recommended)</li>
                          <li>Select your restaurant from the dropdown</li>
                          <li>Click <strong>"Create section"</strong> to save</li>
                        </ol>
                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666", fontFamily: "'Inter', sans-serif" }}>
                          You can edit section names and descriptions or delete sections using the icons in the section header.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>3. Adding Dishes</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Once you have sections created, you can add dishes to your menu.</p>
                        <ol>
                          <li>Click <strong>"+ Add product"</strong> within a section, or use the main <strong>"Add New"</strong> dropdown</li>
                          <li>Fill in the dish details:
                            <ul style={{ marginTop: "8px" }}>
                              <li><strong>Name:</strong> The dish name as it appears to customers</li>
                              <li><strong>Description:</strong> Ingredients, preparation style, or special notes</li>
                              <li><strong>Price:</strong> Base price in UGX</li>
                              <li><strong>Image:</strong> High-quality photo of the dish (recommended)</li>
                              <li><strong>Section:</strong> Which menu category this belongs to</li>
                            </ul>
                          </li>
                          <li>Set availability and enable/disable the item</li>
                          <li>Save the dish</li>
                        </ol>
                        <p style={{ marginTop: "10px", padding: "10px", backgroundColor: "#fff3e0", borderLeft: "4px solid #ff9800", fontSize: "13px" }}>
                          <strong>Best Practice:</strong> Use consistent, appealing images and detailed descriptions to increase orders.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>4. Options & Option Groups</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Options allow customers to customize their orders with add-ons, sizes, and variations.</p>

                        <h6 style={{ color: "#17385aff", marginTop: "10px" }}>Creating Options</h6>
                        <ol>
                          <li>Go to the <strong>"Options"</strong> tab</li>
                          <li>Click <strong>"Add Option"</strong></li>
                          <li>Enter the option name (e.g., "Extra Cheese", "Large Size", "Grilled Chicken")</li>
                          <li>Set the additional price for this option</li>
                          <li>Save the option</li>
                        </ol>

                        <h6 style={{ color: "#17385aff", marginTop: "15px" }}>Creating Option Groups</h6>
                        <ol>
                          <li>Go to the <strong>"Option Groups"</strong> tab</li>
                          <li>Click <strong>"Add Option Group"</strong></li>
                          <li>Name the group (e.g., "Choose Size", "Add Toppings", "Select Protein")</li>
                          <li>Select your restaurant</li>
                          <li>Choose which options belong to this group</li>
                          <li>Set minimum and maximum selections:
                            <ul style={{ marginTop: "5px" }}>
                              <li><strong>Min = 1, Max = 1:</strong> Customer must pick exactly one (e.g., size)</li>
                              <li><strong>Min = 0, Max = 5:</strong> Customer can pick up to 5 optional items (e.g., toppings)</li>
                            </ul>
                          </li>
                        </ol>

                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
                          Assign option groups to dishes when creating or editing products to enable customization.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>5. Outlet Management</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>If you operate multiple restaurant locations, the Outlets tab lets you manage location-specific menus and settings.</p>

                        <h6 style={{ color: "#17385aff" }}>Features Available:</h6>
                        <ul>
                          <li>View all your restaurant outlets</li>
                          <li>Configure which sections appear at each outlet</li>
                          <li>Set location-specific operating hours</li>
                          <li>Manage outlet-specific product availability</li>
                        </ul>

                        <p style={{ marginTop: "10px", padding: "10px", backgroundColor: "#e8f5e9", borderLeft: "4px solid #4caf50", fontSize: "13px" }}>
                          <strong>Note:</strong> Use the Outlets tab to customize your menu for different locations while maintaining a centralized menu structure.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>6. Collections (Coming Soon)</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>Collections will allow you to group dishes together for promotional and organizational purposes.</p>

                        <h6 style={{ color: "#17385aff" }}>Planned Features:</h6>
                        <ul>
                          <li><strong>Best Sellers:</strong> Highlight your most popular dishes</li>
                          <li><strong>Combo Deals:</strong> Bundle items together at special prices</li>
                          <li><strong>Seasonal Specials:</strong> Feature limited-time offerings</li>
                          <li><strong>Chef's Recommendations:</strong> Showcase signature dishes</li>
                        </ul>

                        <p style={{ marginTop: "10px", fontSize: "13px", color: "#666" }}>
                          This feature is currently in development. In the meantime, you can use sections creatively to achieve similar results.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6" className="accordion-item-adorned">
                      <Accordion.Header>
                        <strong style={{ fontFamily: "'Inter', sans-serif" }}>7. Using the Simulation Tab</strong>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>The Simulation tab provides a real-time preview of how your menu appears to customers on the web.</p>

                        <h6 style={{ color: "#17385aff" }}>How to Use:</h6>
                        <ol>
                          <li>Click on the <strong>"Simulation"</strong> tab</li>
                          <li>Browse through your sections and dishes as customers would see them</li>
                          <li>Check the following:
                            <ul style={{ marginTop: "8px" }}>
                              <li>Images are clear, properly sized, and appetizing</li>
                              <li>Descriptions are informative and well-written</li>
                              <li>Prices display correctly in UGX format</li>
                              <li>Section organization makes sense</li>
                              <li>Only enabled items are visible</li>
                            </ul>
                          </li>
                          <li>Return to <strong>"Menu Overview"</strong> to make any necessary adjustments</li>
                        </ol>

                        <p style={{ marginTop: "15px", padding: "10px", backgroundColor: "#fff3e0", borderLeft: "4px solid #ff9800", fontSize: "13px" }}>
                          <strong>Pro Tip:</strong> Use consistent image sizes and maintain similar description lengths for a professional, uniform appearance. The simulation updates instantly as you make changes!
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal for creating a new section */}

      {/* Bulk menu import (workbook + photos) */}
      <MenuImportModal
        show={showMenuImport}
        restaurant={{
          _id: (restaurants && restaurants[0] && restaurants[0]._id) || vendorId,
          owner: vendorId,
          name:
            (restaurants && restaurants[0] && restaurants[0].name) ||
            "your restaurant",
          imageUrl: restaurants && restaurants[0] && restaurants[0].imageUrl,
        }}
        existingSections={sections}
        onClose={() => setShowMenuImport(false)}
        onImported={() => {
          dispatch(fetchSections(vendorId));
          dispatch(fetchOptionGroupsRestaurant(vendorId));
          dispatch(fetchOptionsRestaurants(vendorId));
        }}
      />

      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} className="modal-adorned">
        <Modal.Header closeButton>
          <Modal.Title>Create a new section</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="sectionTitle">
              <Form.Label>Section title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section title..."
                value={sectionTitle}
                onChange={(e) => setSectionTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="sectionDescription">
              <Form.Label>Section description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section description..."
                value={sectionDescription}
                onChange={(e) => setSectionDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="restaurantSelect">
              <Form.Label>Select Restaurant</Form.Label>
              <AppSelect block
                value={selectedRestaurantId}
                onChange={(e) => {
                  setSelectedRestaurantId(e.target.value);
                  setRestaurantRequired(false);
                }}
                style={{ borderColor: restaurantRequired ? "red" : "" }}
              >
                <option value="" disabled>
                  Select a restaurant
                </option>
                {restaurants.map((restaurant) => (
                  <option key={restaurant._id} value={restaurant.owner}>
                    {restaurant.name}
                  </option>
                ))}
              </AppSelect>
              {restaurantRequired && (
                <Form.Text style={{ color: "red" }}>
                  Please select a restaurant.
                </Form.Text>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleMenuSectionSubmit}>
            Create section
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing a section */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} className="modal-adorned">
        <Modal.Header closeButton>
          <Modal.Title>Edit section</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="sectionTitleEdit">
              <Form.Label>Section title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section title..."
                value={sectionTitle}
                onChange={(e) => setSectionTitle(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="sectionDescriptionEdit">
              <Form.Label>Section description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter section description..."
                value={sectionDescription}
                onChange={(e) => setSectionDescription(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="restaurantSelectEdit">
              <Form.Label>Select Restaurant</Form.Label>
              <AppSelect block
                value={selectedRestaurantId}
                onChange={(e) => {
                  setSelectedRestaurantId(e.target.value);
                  setRestaurantRequired(false);
                }}
                style={{ borderColor: restaurantRequired ? "red" : "" }}
              >
                <option value="" disabled>
                  Select a restaurant
                </option>
                {restaurants.map((restaurant) => (
                  <option key={restaurant._id} value={restaurant.owner}>
                    {restaurant.name}
                  </option>
                ))}
              </AppSelect>
              {restaurantRequired && (
                <Form.Text style={{ color: "red" }}>
                  Please select a restaurant.
                </Form.Text>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSectionEditSubmit}>
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating a new option */}
      <Modal show={showOptionModal} onHide={() => setShowOptionModal(false)} className="modal-adorned">
        <Modal.Header closeButton>
          <Modal.Title>Create a new option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="optionName">
              <Form.Label>Option name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option name..."
                value={optionName}
                onChange={(e) => setOptionName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="optionPrice">
              <Form.Label>Option price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter option price..."
                value={optionPrice}
                onChange={(e) => setOptionPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOptionModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleOptionSubmit}>
            Create option
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for creating or editing an option group */}
      <Modal show={showOptionGroupModal} onHide={handleCloseOptionGroupModal} className="modal-adorned" size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #17385aff 0%, #0a578bff 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}>
              <MdTune size={20} />
            </div>
            {currentOptionGroupId
              ? "Edit Option Group"
              : "Create Option Group"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <Form>
            {/* Quick Presets Section - shown for both create and edit */}
            {(
              <div style={{
                marginBottom: "24px",
                padding: "16px",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                borderRadius: "12px",
                border: "1px solid #e9ecef"
              }}>
                <Form.Label style={{ fontWeight: "600", color: "#17385aff", marginBottom: "12px", display: "block" }}>
                  Quick Presets
                </Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    size="sm"
                    onClick={() => {
                      setMinOptions(1);
                      setMaxOptions(1);
                    }}
                    style={{
                      borderRadius: "20px",
                      padding: "8px 18px",
                      fontWeight: "600",
                      fontSize: "13px",
                      border: "none",
                      color: "#ffffff",
                      background: minOptions === 1 && maxOptions === 1 ? "#047857" : "#059669",
                    }}
                  >
                    Pick One (e.g., Free Drink)
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setMinOptions(0);
                      setMaxOptions(3);
                    }}
                    style={{
                      borderRadius: "20px",
                      padding: "8px 18px",
                      fontWeight: "600",
                      fontSize: "13px",
                      border: "none",
                      color: "#ffffff",
                      background: minOptions === 0 && maxOptions === 3 ? "#0f172a" : "#1e3a5f",
                    }}
                  >
                    Optional (Up to 3)
                  </Button>
                  <Button
                    size="sm"
                    onClick={() => {
                      setMinOptions(1);
                      setMaxOptions(0);
                    }}
                    style={{
                      borderRadius: "20px",
                      padding: "8px 18px",
                      fontWeight: "600",
                      fontSize: "13px",
                      border: "none",
                      color: "#ffffff",
                      background: minOptions === 1 && maxOptions === 0 ? "#b45309" : "#d97706",
                    }}
                  >
                    Required (Unlimited)
                  </Button>
                </div>
              </div>
            )}

            <Form.Group controlId="optionGroupName" className="mb-3">
              <Form.Label style={{ fontWeight: "600", color: "#495057" }}>Option Group Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="e.g., Free Drink, Size, Toppings..."
                value={optionGroupName}
                onChange={(e) => setOptionGroupName(e.target.value)}
                style={{
                  borderRadius: "10px",
                  padding: "12px 16px",
                  border: "1px solid #e9ecef",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                }}
              />
            </Form.Group>

            <Form.Group controlId="restaurantSelectOptionGroup" className="mb-3">
              <Form.Label style={{ fontWeight: "600", color: "#495057" }}>Select Restaurant</Form.Label>
              <AppSelect block
                value={selectedRestaurantId}
                onChange={(e) => {
                  setSelectedRestaurantId(e.target.value);
                  setRestaurantRequired(false);
                }}
                style={{
                  borderRadius: "10px",
                  padding: "12px 16px",
                  border: restaurantRequired ? "1px solid #dc3545" : "1px solid #e9ecef",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                }}
              >
                <option value="" disabled>
                  Select a restaurant
                </option>
                {restaurants.map((restaurant) => (
                  <option key={restaurant._id} value={restaurant.owner}>
                    {restaurant.name}
                  </option>
                ))}
              </AppSelect>
              {restaurantRequired && (
                <Form.Text style={{ color: "#dc3545", fontSize: "12px" }}>
                  Please select a restaurant.
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group controlId="optionSelect" className="mb-3">
              <Form.Label style={{ fontWeight: "600", color: "#495057" }}>Select Options</Form.Label>
              <Select
                isMulti
                options={options.map((option) => ({
                  value: option._id,
                  label: `${option.name} - ${new Intl.NumberFormat("en-UG", {
                    style: "currency",
                    currency: "UGX",
                  }).format(option.price)}`,
                  mandatory: false,
                }))}
                value={selectedOptions}
                onChange={setSelectedOptions}
                placeholder="Search and select options..."
                formatOptionLabel={(option, { context }) => (
                  <div className="d-flex justify-content-between align-items-center">
                    <span>{option.label}</span>
                    <Form.Check
                      type="checkbox"
                      checked={selectedOptions.some(
                        (selectedOption) =>
                          selectedOption.value === option.value &&
                          selectedOption.mandatory
                      )}
                      onChange={(e) => {
                        const updatedOptions = selectedOptions.map((opt) =>
                          opt.value === option.value
                            ? { ...opt, mandatory: e.target.checked }
                            : opt
                        );
                        setSelectedOptions(updatedOptions);
                      }}
                      label="Mandatory"
                      className="ml-2"
                    />
                  </div>
                )}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "10px",
                    border: "1px solid #e9ecef",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                    padding: "4px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#e3f2fd",
                    borderRadius: "6px",
                  }),
                }}
              />
              {options.length === 0 && (
                <Form.Text style={{ color: "#6c757d", fontSize: "12px" }}>
                  No options available. Create options first in the "Options" tab.
                </Form.Text>
              )}
            </Form.Group>

            {/* Selection Rules */}
            <div style={{
              background: "#f8f9fa",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "16px"
            }}>
              <Form.Label style={{ fontWeight: "600", color: "#17385aff", marginBottom: "12px", display: "block" }}>
                Selection Rules
              </Form.Label>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="minOptions">
                    <Form.Label style={{ fontSize: "13px", color: "#495057" }}>
                      Minimum Selections
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Set to 1 or more to make this group required</Tooltip>}
                      >
                        <FaInfoCircle style={{ marginLeft: "6px", color: "#6c757d", cursor: "help" }} size={12} />
                      </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="0"
                      value={minOptions}
                      onChange={(e) => {
                        const value = parseInt(e.target.value);
                        setMinOptions(value < 0 ? 0 : value);
                      }}
                      min="0"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="maxOptions">
                    <Form.Label style={{ fontSize: "13px", color: "#495057" }}>
                      Maximum Selections
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Set to 0 for unlimited selections, or 1 for "pick one" scenarios</Tooltip>}
                      >
                        <FaInfoCircle style={{ marginLeft: "6px", color: "#6c757d", cursor: "help" }} size={12} />
                      </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="0 = Unlimited"
                      value={maxOptions}
                      onChange={(e) => {
                        const value = parseInt(e.target.value);
                        setMaxOptions(value < 0 ? 0 : value);
                      }}
                      min="0"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Dynamic hint based on current settings */}
              <Alert
                variant={minOptions === 1 && maxOptions === 1 ? "success" : minOptions > 0 ? "warning" : "info"}
                style={{
                  marginTop: "12px",
                  marginBottom: 0,
                  fontSize: "13px",
                  borderRadius: "8px",
                  padding: "10px 14px"
                }}
              >
                <strong>
                  {minOptions === 1 && maxOptions === 1
                    ? "Pick One: "
                    : minOptions > 0
                      ? "Required: "
                      : "Optional: "}
                </strong>
                {minOptions === 1 && maxOptions === 1
                  ? "Customer must select exactly one option (ideal for free drinks, sizes, etc.)"
                  : minOptions > 0 && maxOptions === 0
                    ? `Customer must select at least ${minOptions} option(s), no limit on maximum`
                    : minOptions > 0 && maxOptions > 0
                      ? `Customer must select between ${minOptions} and ${maxOptions} option(s)`
                      : maxOptions > 0
                        ? `Customer can optionally select up to ${maxOptions} option(s)`
                        : "Customer can optionally select any number of options"}
              </Alert>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseOptionGroupModal}
            disabled={optionLoading}
          >
            {optionLoading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "black" }}
                />
                <span style={{ color: "black" }}> Updating...</span>
              </>
            ) : (
              "Discard Changes"
            )}
          </Button>
          <Button
            variant="success"
            onClick={handleOptionGroupSubmit}
            disabled={optionLoading}
          >
            {optionLoading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "black" }}
                />
                <span style={{ color: "black" }}> Updating...</span>
              </>
            ) : currentOptionGroupId ? (
              "Update Option Group"
            ) : (
              "Create Option Group"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete confirmation */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} className="modal-adorned">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this section and all its products?
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={confirmDeleteSection}
            disabled={isLoadingDeleteOptionGroup}
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
              color: isLoadingDeleteOptionGroup ? "black" : "white",
            }}
          >
            {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete option group confirmation */}
      <Modal
        show={showOptionGroupDeleteModal}
        onHide={() => setShowOptionGroupDeleteModal(false)}
        className="modal-adorned"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this option group? This action cannot
          be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOptionGroupDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
            style={{
              color: isLoadingDeleteOptionGroup ? "black" : "white",
            }}
          >
            Cancel
          </Button>
          <div
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
            }}
          >
            <Button
              variant="danger"
              onClick={confirmDeleteOptionGroup}
              disabled={isLoadingDeleteOptionGroup}
              style={{
                cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
                color: isLoadingDeleteOptionGroup ? "black" : "white",
              }}
            >
              {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal for delete option confirmation */}
      <Modal
        show={showOptionDeleteModal}
        onHide={() => setShowOptionDeleteModal(false)}
        className="modal-adorned"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this option? This action cannot be
          undone.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowOptionDeleteModal(false)}
            disabled={isLoadingDeleteOptionGroup}
            style={{
              color: isLoadingDeleteOptionGroup ? "black" : "white",
            }}
          >
            Cancel
          </Button>
          <div
            style={{
              cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
            }}
          >
            <Button
              variant="danger"
              onClick={confirmDeleteOption}
              disabled={isLoadingDeleteOptionGroup}
              style={{
                cursor: isLoadingDeleteOptionGroup ? "not-allowed" : "pointer",
                color: isLoadingDeleteOptionGroup ? "black" : "white",
              }}
            >
              {isLoadingDeleteOptionGroup ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing an option */}
      <Modal
        show={showEditOptionModal}
        onHide={() => setShowEditOptionModal(false)}
        className="modal-adorned"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="editOptionName">
              <Form.Label>Option Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter option name..."
                value={editOptionName}
                onChange={(e) => setEditOptionName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="editOptionPrice">
              <Form.Label>Option Price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter option price..."
                value={editOptionPrice}
                onChange={(e) => setEditOptionPrice(parseFloat(e.target.value))}
              />
            </Form.Group>
            <Form.Group controlId="editOptionEnabled">
              <Form.Label>Enabled</Form.Label>
              <Switch
                checked={editOptionEnabled}
                onChange={(e) => setEditOptionEnabled(e.target.checked)}
                color="primary"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowEditOptionModal(false)}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={handleEditOptionSubmit}>
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Collection Modal */}
      <Modal
        show={showCollectionModal}
        onHide={() => setShowCollectionModal(false)}
        className="modal-adorned"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <MdFolder size={24} style={{ marginRight: "8px", verticalAlign: "middle" }} />
            Create New Collection
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="form-label-adorned">Collection Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter collection name (e.g., 'Best Sellers', 'Lunch Specials')"
                value={collectionName}
                onChange={(e) => setCollectionName(e.target.value)}
                className="form-control-adorned"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="form-label-adorned">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter collection description (optional)"
                value={collectionDescription}
                onChange={(e) => setCollectionDescription(e.target.value)}
                className="form-control-adorned"
              />
            </Form.Group>

            <Alert variant="info" style={{ fontSize: "14px", marginTop: "16px" }}>
              <FaInfoCircle style={{ marginRight: "8px" }} />
              Collections help you group products together for easier organization and display.
              This feature is coming soon!
            </Alert>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-adorned-secondary"
            onClick={() => {
              setShowCollectionModal(false);
              setCollectionName("");
              setCollectionDescription("");
            }}
          >
            Cancel
          </Button>
          <Button
            className="btn-adorned-primary"
            onClick={() => {
              // TODO: Implement collection creation
              toast.info("Collection feature coming soon!");
              setShowCollectionModal(false);
              setCollectionName("");
              setCollectionDescription("");
            }}
            disabled={!collectionName.trim()}
          >
            Create Collection
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Floating Image Preview */}
      {hoveredImage && (
        <div
          style={{
            position: "fixed",
            left: Math.min(imagePreviewPosition.x, window.innerWidth - 420),
            top: Math.max(20, Math.min(imagePreviewPosition.y, window.innerHeight - 420)),
            zIndex: 9999,
            pointerEvents: "none",
            animation: "fadeIn 0.2s ease-out",
          }}
        >
          <div
            style={{
              width: "400px",
              height: "400px",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              border: "4px solid white",
              background: "#f8f9fa",
            }}
          >
            <img
              src={hoveredImage}
              alt="Product preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      )}
    </Col>
  );
};

export default RestaurantVendorMenu;
